import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private tenantId$ = new BehaviorSubject<string | null>(
    localStorage.getItem('activeTenantId')
  );

  getTenantId$() {
    return this.tenantId$.asObservable();
  }

  setTenantId(id: string | null) {
    this.tenantId$.next(id);
  }
}
